import {
  Action,
  ActionType,
  IFullStressTypeInfoResponse,
} from "models/stressCheck/fullStressInformation";
import createReducer from "redux/createReducer";

export interface FullStressCheckTypeInfoReducerType {
  loading: boolean;
  error?: string;
  fullStressCheckTypeInfoResponse?: IFullStressTypeInfoResponse;
}

const defaultState: FullStressCheckTypeInfoReducerType = {
  loading: false,
  error: undefined,
  fullStressCheckTypeInfoResponse: undefined,
};

export const fullStressCheckTypeInfoReducer =
  createReducer<FullStressCheckTypeInfoReducerType>(defaultState, {
    [ActionType.FULL_STRESS_INFO](state: FullStressCheckTypeInfoReducerType) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.FULL_STRESS_INFO_ERROR](
      state: FullStressCheckTypeInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        fullStressCheckTypeInfoResponse: undefined,
      };
    },

    [ActionType.FULL_STRESS_INFO_SUCCESS](
      state: FullStressCheckTypeInfoReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressCheckTypeInfoResponse: action.payload,
      };
    },

    [ActionType.FULL_STRESS_INFO_RESET_DATA](
      state: FullStressCheckTypeInfoReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        fullStressCheckTypeInfoResponse: undefined,
      };
    },
  });
